import NavigationBar from "carbon-react/esm/components/navigation-bar";
import { Menu, MenuItem } from "carbon-react/esm/components/menu";

const navigationItems = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "Lenders", path: "/lenders" },
  { label: "Loans", path: "/loans" },
  { label: "Posting", path: "/posting" },
  { label: "Reconciliation", path: "/reconciliation" },
  { label: "Reports", path: "/reports" },
  { label: "Settings", path: "/settings" },
] as const;

interface ApplicationNavigationProps {
  currentPath: string;
  onNavigate(path: string): void;
}

export function ApplicationNavigation({ currentPath, onNavigate }: ApplicationNavigationProps) {
  return (
    <header className="application-header">
      <div className="application-header__row">
        <div className="application-header__identity">
          <span aria-hidden="true" className="application-header__mark">LM</span>
          <span className="application-header__name">Loan Management</span>
          <span className="application-header__descriptor">for Borrowers</span>
        </div>
        <NavigationBar ariaLabel="Loan Management sections" navigationType="white">
          <Menu menuType="white" overflowX="auto">
            {navigationItems.map((item) => {
              const selected = routeBelongsToSection(currentPath, item.path);
              return (
                <MenuItem
                  ariaCurrent={selected ? "page" : undefined}
                  href={item.path}
                  key={item.path}
                  onClick={(event) => {
                    event.preventDefault();
                    onNavigate(item.path);
                  }}
                  selected={selected}
                >
                  {item.label}
                </MenuItem>
              );
            })}
          </Menu>
        </NavigationBar>
        <div className="application-header__attribution">
          <span className="application-header__name">Powered by </span>
          <span className="application-header__descriptor">Campbell Technology Advisors LLC</span>
        </div>
      </div>
    </header>
  );
}

function routeBelongsToSection(currentPath: string, sectionPath: string): boolean {
  if (sectionPath === "/dashboard") return currentPath === sectionPath;
  return currentPath === sectionPath || currentPath.startsWith(`${sectionPath}/`);
}